var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"onfFileInput",staticClass:"onf-file-input dropzone"})
}
var staticRenderFns = []

export { render, staticRenderFns }